"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var Input_1 = __importDefault(require("../Input"));
var icons_1 = require("../../../icons");
var style_1 = require("../../../style");
var react_2 = require("react");
var ICON_SIZE_MAP = {
    small: "var(" + style_1.ComponentLayout.INPUT_ICON_SIZE_SM + ")",
    default: "var(" + style_1.ComponentLayout.INPUT_ICON_SIZE_MD + ")",
    large: "var(" + style_1.ComponentLayout.INPUT_ICON_SIZE_LG + ")",
};
var nativeInputValueSetter = (_a = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')) === null || _a === void 0 ? void 0 : _a.set;
var Search = function (props) {
    var ref = react_2.useRef(null);
    var _a = react_2.useState(false), hasValue = _a[0], setHasValue = _a[1];
    var after = react_2.useMemo(function () { return hasValue ? (react_1.jsx(icons_1.XCircle, { size: ICON_SIZE_MAP[props.size || 'default'], css: { cursor: 'pointer' }, onClick: function () {
            if (ref.current) {
                nativeInputValueSetter === null || nativeInputValueSetter === void 0 ? void 0 : nativeInputValueSetter.call(ref.current, '');
                var event_1 = new Event('input', { bubbles: true });
                ref.current.dispatchEvent(event_1);
            }
        } })) : null; }, [hasValue, props.size]);
    return (react_1.jsx(Input_1.default, __assign({}, props, { before: react_1.jsx(icons_1.SearchSm, { size: ICON_SIZE_MAP[props.size || 'default'] }), after: after, ref: ref, placeholder: props.placeholder || 'Search..', inputProps: __assign(__assign({}, props.inputProps), { onChange: function (e) {
                var _a, _b, _c;
                (_b = (_a = props.inputProps) === null || _a === void 0 ? void 0 : _a.onChange) === null || _b === void 0 ? void 0 : _b.call(_a, e);
                (_c = props.onChange) === null || _c === void 0 ? void 0 : _c.call(props, e.target.value, e);
                setHasValue(!!e.target.value);
            } }) })));
};
exports.default = Search;
